import { parseTemplate } from 'url-template';
import ApiClient from '~/ApiClient';

import { Settings } from './Settings';

export interface Result {
	roMaxPriceSettings: Settings;
}

export const update = async (client: ApiClient, userId: string, settings: Settings): Promise<Result> => {
	const url = parseTemplate('users/{userId}/ro-max-price-settings');
	const response = await client.fetch(url.expand({ userId }), {
		method: 'PUT',
		body: JSON.stringify(settings),
	});
	return response.json();
};
